module.exports = __webpack_public_path__ + "static/media/dashboard-scape-card-5-icon.9b6ff1b6.svg";